import { WorkflowTemplate } from '@digital-twins/shared-types'

import { RememberedAudience } from './useArmedWorkflowState'

/**
 * The display name behind an armed workflow's `audience` input, resolved from
 * what the page already holds: the ready audience list first, then the
 * remembered audience when it is the same id. `null` when the template has no
 * audience input, nothing is bound, or nothing loaded can name the id — the
 * caller then shows no audience chip rather than a blank one.
 *
 * ONE resolver for the confirm card, the composer chips, the user-turn chip
 * and the intake payload (plan 2026-09-14-twin-test-bound-audience, D4).
 */
export function audienceNameForInputs(
  template: WorkflowTemplate,
  values: Record<string, string | null>,
  audiences: Array<{ id: string; name: string }>,
  rememberedAudience: RememberedAudience | null | undefined,
): string | null {
  const audienceSpec = template.inputs.find((spec) => spec.type === 'audience')
  if (!audienceSpec) {
    return null
  }

  const audienceId = values[audienceSpec.key]
  if (!audienceId) {
    return null
  }

  const fromList = audiences.find((entry) => entry.id === audienceId)
  if (fromList) {
    return fromList.name
  }

  if (rememberedAudience?.audienceId === audienceId) {
    return rememberedAudience.audienceName
  }

  return null
}
